<template>
	<v-dialog persistent @click:outside="closeDialog()" :value="true" max-width="450" >
		<v-card >
			<v-card-title>
				{{ $vuetify.lang.t('$vuetify.views.chat.errors.tooManyExpanded') }}
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				{{ $vuetify.lang.t('$vuetify.views.chat.messages.popupNotFit') }}<br>
				{{ $vuetify.lang.t('$vuetify.views.chat.messages.wannaOpenInMessenger') }}
			</v-card-text>
			<v-card-actions class="py-3">
				<v-btn @click="closeDialog()" class="ml-auto"> {{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn :to="url" @click="closeDialog()" color="primary"> {{ $vuetify.lang.t('$vuetify.views.chat.goToChat') }} <v-icon class="ml-2">$external-link</v-icon></v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		room: {
			required: true,
			type: Object
		}
	},
	data() {
		return {

		}
	},
	computed: {
		url() {
			return {
				name: 'Chat',
				params: {
					hash: this.room.hash
				}
			}
		}
	},
	methods: {
		closeDialog() {
			this.$emit('close');
		}
	}
}
</script>
